import { Tooltip } from '@material-ui/core';
import React from 'react';
import { white50 } from '../../Styles/Colours';
import { Button, ButtonMode, ButtonVariant } from '../Button';
import { StyledDialog } from '../Dialog/StyledDialog';
import { StyledDialogButton } from '../Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Dialog/StyledDialogContent';
import { CloseIcon } from '../Icons';
import styles from './DeleteDialog.module.scss';

export const DeleteDialog: React.FC<{
    title: string;
    disabled?: boolean;
    testId: string;
    onOk(event: React.MouseEvent): void;
    onCancel(event: React.MouseEvent): void;
}> = props => {
    const actionButtons = [
        <StyledDialogButton
            mode={ButtonMode.solid}
            variant={ButtonVariant.light}
            key='cancel'
            onClick={props.onCancel}
            width={94}
            testId={`${props.testId}-cancel`}
        >
            Cancel
        </StyledDialogButton>,
        <StyledDialogButton
            key='delete'
            testId={`${props.testId}-ok`}
            onClick={props.onOk}
            width={94}
            variant={ButtonVariant.danger}
        >
            Delete
        </StyledDialogButton>
    ];

    return (
        <StyledDialog
            open
            size='xxxs'
            modal
            titleComponent={
                <div className={styles.header}>
                    <div className={styles.title}>{props.title}</div>
                    <div className={styles.close}>
                        <Tooltip title={'Close'}>
                            <span>
                                <Button
                                    iconOnly
                                    onClick={props.onCancel}
                                    mode={ButtonMode.text}
                                    noShadowOnHover
                                    subtleShadeOnHover
                                    testId={`${props.testId}-close`}
                                >
                                    <CloseIcon size='24' color={white50} noPadding />
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                </div>
            }
            testId={props.testId}
            actions={actionButtons}
            onRequestClose={props.onCancel}
            contentComponent={
                <StyledDialogContent noPadding>
                    <div className={styles.contents}>{props.children}</div>
                </StyledDialogContent>
            }
        />
    );
};
